<template>
  <div>
    <div class="tableContainer mx-auto">
      <Toast position="bottom-right" group="br" />
      <div class="d-flex my-3">
        <h6>All {{ companyName }} Company Main Routes</h6>
        <div class="add-btn ml-auto">
          <button
            class="btn show-modal"
            data-toggle="modal"
            data-target="#myModal"
            :disabled="branches == null || branches.length == 0"
            title="To register a route you must have registered branches"
          >
            Add Route
          </button>
        </div>
      </div>
      <div class="modal fade" id="myModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form col-lg-12 mx-auto bg-white">
                <h6 class="text-center mt-2 mb-3 heading">
                  Register new route
                </h6>
                <form method="post" class="add-route-form col-lg-11 mx-auto">
                  <div class="inputs d-flex flex-wrap mx-auto">
                    <div class="form-group col-sm-6 col-12 col-lg-4">
                      <select
                        class="form-control"
                        v-model="source"
                        name="source"
                      >
                        <option
                          v-if="branches != null || branches.length != 0"
                          value=""
                          disabled
                          selected
                          >Select route source</option
                        >
                        <option v-else value="" selected disabled
                          >To get source go register a branch</option
                        >
                        <option v-for="branch in branches" :key="branch.branchname">{{
                          branch.branchname
                        }}</option>
                      </select>
                    </div>
                    <div class="form-group col-sm-6 col-12 col-lg-5">
                      <select
                        class="form-control"
                        v-model="destination"
                        name="destination"
                      >
                        <option
                          v-if="branches != null || branches.length != 0"
                          value=""
                          disabled
                          selected
                          >Select route destination</option
                        >
                        <option v-else value="" selected disabled
                          >Impossibe to register route without a branch</option
                        >
                        <option v-for="branch in branches" :key="branch.branchname">{{
                          branch.branchname
                        }}</option>
                      </select>
                    </div>
                    <div
                      class="
                        text-center
                        saveroute
                        col-12 col-sm-6 col-lg-2
                      "
                    >
                      <button
                        class="btn btn-primary col-12 col-sm-12"
                        type="submit"
                        name="newroute"
                        @click.prevent="newRoute()"
                      >
                        Add route
                        <span
                          v-if="hasSubmitted"
                          class="spinner-border spinner-border-sm ml-2 my-auto"
                        ></span>
                      </button>
                    </div>
                  </div>
                </form>

                <div class="added-buses col-lg-12 col-12 mx-auto">
                  <div v-if="!showTable" class="table_placeholder">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="120"
                        height="120"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                          d="M4 15V8.5a4.5 4.5 0 0 1 9 0v7a2.5 2.5 0 1 0 5 0V8.83a3.001 3.001 0 1 1 2 0v6.67a4.5 4.5 0 1 1-9 0v-7a2.5 2.5 0 0 0-5 0V15h3l-4 5-4-5h3zm15-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                          fill="rgba(149,164,166,1)"
                        />
                      </svg>
                      <p id="add-buses-text">Added routes will appear here</p>
                    </div>
                  </div>
                  <div
                    v-if="showTable"
                    class="table-container card my-3 col-lg-11 p-0 mx-auto"
                  >
                    <table class="table col-lg-12">
                      <thead class="bg-success">
                        <tr>
                          <th>From</th>
                          <th>To</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="route in Routes" :key="route">
                          <td class="text-break">{{ route.source }}</td>
                          <td class="text-break">{{ route.destination }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="decision-btns ml-auto">
                  <button
                    class="btn px-5"
                    @click="clearTable"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card table-view">
        <DataTable
          :value="Routes"
          :paginator="true"
          class="p-datatable-customers"
          :rows="10"
          v-model:selection="selectedProducts3"
          dataKey="id"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 20, 50]"
          v-model:filters="filters2"
          filterDisplay="row"
          :loading="LoadingData"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          :globalFilterFields="['routeid', 'source', 'destination']"
        >
          <template #header>
            <div class="p-d-flex p-jc-end">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters2['global'].value"
                  placeholder="Keyword Search"
                />
              </span>
            </div>
          </template>
          <template #empty> No Routes found. </template>
          <template #loading> Loading Routes data. Please wait. </template>
          <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
          <Column
            field="source"
            header="Route source"
            sortable="true"
            style="min-width: 12rem"
          >
            <template #body="{ data }">
              {{ data.source }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['source'].value"
                class="p-column-filter"
                :placeholder="`Search by source - `"
              />
            </template>
          </Column>

          <Column
            field="destination"
            header="Route destination"
            sortable="true"
            style="min-width: 12rem"
          >
            <template #body="{ data }">
              {{ data.destination }}
            </template>
            <template #filter>
              <InputText
                type="text"
                v-model="filters2['destination'].value"
                class="p-column-filter"
                :placeholder="`Search by destination - `"
              />
            </template>
          </Column>
        </DataTable>
      </div>

      <!-- table card for mobile -->

      <div class="card mobile_cards_instead_of_table">
        <DataView
          :value="Routes"
          :paginator="true"
          :rows="9"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        >
          <template #empty> No Routes found. </template>
          <template #list="slotProps">
            <div class="p-col-12">
              <div class="col-sm-12 col-12 single-card">
                <div class="sub-content d-flex">
                  <p class="title">Route source:</p>
                  <p class="content pl-2">
                    {{ slotProps.data.source }}
                  </p>
                </div>
                <div class="sub-content d-flex">
                  <p class="title">Route destination:</p>
                  <p class="content pl-2">{{ slotProps.data.destination }}</p>
                </div>
              </div>
            </div>
          </template>
        </DataView>
      </div>

      <div class="d-flex loader" v-if="LoadingData">
        <span
          v-if="true"
          class="spinner-border spinner-border-sm ml-2 my-auto"
        ></span>
        <p>Please wait. We are loading data...</p>
      </div>
    </div>
  </div>
</template>
<script>
import AdminSidebar from "@/components/adminSidebar.vue";
//Bootstrap and jQuery libraries
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import { FilterMatchMode } from "primevue/api";
import $ from "jquery";
import axios from "axios";
import jwt_decode from "jwt-decode";
const companyName = localStorage.getItem("companyName");
const RoutesUrl = `https://bookinga.herokuapp.com/api/v1/company/routes`;
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  components: {
    AdminSidebar,
  },
  data: function() {
    return {
      selectedProducts3: null,
      filters2: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        source: { value: null, matchMode: FilterMatchMode.CONTAINS },
        destination: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      companyName: companyName,
      Routes: [],
      AddedRoutes: [],
      branches: [],
      hasSubmitted: false,
      errors: false,
      success: false,
      showTable: false,
      modalClose: "",
      LoadingData: true,
      source: "",
      destination: "",
    };
  },
  mounted() {
    //API Call
    this.getRoutes();
    this.returnBranches();
  },
  watch: {
    AddedRoutes: {
      handler(val, oldVal) {
        this.getRoutes();
      },
      deep: true,
    },
  },
  methods: {
    returnBranches() {
      axios.get("https://bookinga.herokuapp.com/api/v1/company/branches/", config).then((res) => {
        this.branches = res.data.data;
      });
    },
    getRoutes() {
      axios.get(RoutesUrl, config).then((res) => {
        if ((res.data.message != "No routes for your company")) {
          this.Routes = res.data.data;
          this.LoadingData = false;
        }
        else{
          this.LoadingData=false;
        }
      });
    },
    clearTable() {
      this.AddedRoutes.unshift();
      this.showTable = false;
    },
    newRoute() {
      if (this.source != "" && this.destination != "") {
        if (this.source != this.destination) {
          this.hasSubmitted = !this.hasSubmitted;
          axios
            .post(
              RoutesUrl,
              {
                source: this.source,
                destination: this.destination,
              },
              config
            )
            .then((response) => {
              if (response.data.status == 201) {
                this.$toast.add({
                  severity: "success",
                  summary: "routes registration",
                  detail: "route registered successfully",
                  group: "br",
                  life: 5000,
                });
                this.showTable = true;
                this.hasSubmitted = false;
                this.clicksCounter++;
                this.AddedRoutes.push({
                  no: this.clicksCounter,
                  seats: this.source,
                  destination: this.destination,
                });
                this.source = "";
                this.destination = "";
              } else {
                this.hasSubmitted = false;
                this.showTable = false;
                return this.$toast.add({
                  severity: "error",
                  summary: "An error occured",
                  detail: response.data.message,
                  group: "br",
                  life: 5000,
                });
              }
            })
            .catch((err) => {
              this.hasSubmitted = false;
              this.showTable = false;
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: "Wasn't able to add route, please try again!",
                group: "br",
                life: 5000,
              });
            });
        } else {
          return this.$toast.add({
            severity: "error",
            summary: "An error occured",
            detail: "Source and destination can't be similar",
            group: "br",
            life: 5000,
          });
        }
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          group: "br",
          detail: "A route should have all the 2 fields",
          life: 5000,
        });
      }
    },
  },
  created() {
    // const token = localStorage.getItem("jwt");
    // const decoded = jwt_decode(token);
    // const userRole = decoded.role;
    // if ( userRole != "admin") {
    //   return router.push("/dashboard");
    // }
    
    $(document).ready(function() {
      $(".show-modal").click(function() {
        $("#myModal").modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    });
  },
};
</script>
<style lang="scss" scoped>
@import "../sharedStyles.scss";

.add-route-form {
  display: flex;
  justify-content: center;
  margin: 0 auto !important;
  width: 99%;
}
.form-control {
  margin: 0 !important;
}
.form-group,
.saveroute {
  margin-bottom: 0 !important;
  padding: 0;
  margin: 10px 10px;
}
.inputs {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
}
</style>
